<template>
  <div
    class="fixed pointer-events-none p-4 md:p-8 lg:p-0 pr-0 left-0 text-xs z-0 w-full h-full select-none"
  >
    <div
      v-for="(row, index) in rows"
      :key="index"
      class="grid grid-cols-12 w-full h-1/7"
    >
      <span
        v-for="(column, i) in columns"
        :key="column"
        class="uppercase pt-0 lg:pt-8"
      >
        <template v-if="i >= limit">{{ text[index] }}</template>
        <template v-else>&nbsp;</template>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "GridLetters",
  props: {
    text: String,
  },
  data() {
    return {
      columns: 12,
      limit: 1,
    };
  },
  mounted() {
    if (window.innerWidth < 1024) {
      this.limit = 0;
    } else {
      this.limit = 2;
    }
    window.addEventListener("resize", () => {
      if (window.innerWidth < 1024) {
        this.limit = 0;
      } else {
        this.limit = 2;
      }
    });
  },
  computed: {
    rows() {
      return this.text.length;
    },
  },
};
</script>
